/** Rechte des angemeldeten Benutzers (GET /api/me/rechte).
    Schlüssel wie "auftrag.lesen" (KEINE|EIGENE|ZUGEWIESENE|ALLE),
    "faehigkeit.preise_sehen" und "agent.<modul>" (NEIN|JA). */
export type Rechte = Record<string, string>;

export const BEREICHE = ['KEINE', 'EIGENE', 'ZUGEWIESENE', 'ALLE'];

/** Ordnungszahl eines Rechtewerts: Bereichsstufe, JA = 1, NEIN/unbekannt = 0. */
export function rang(wert: string): number {
  if (wert === 'JA') return 1;
  const i = BEREICHE.indexOf(wert);
  return i < 0 ? 0 : i;
}

/** Wert vorhanden und weder KEINE noch NEIN (fail-closed: fehlend = kein Recht). */
export function hatRecht(rechte: Rechte, schluessel: string): boolean {
  const wert = rechte[schluessel];
  return wert !== undefined && wert !== 'KEINE' && wert !== 'NEIN';
}

/** Darf der Benutzer Preise und Summen sehen? */
export function darfPreise(rechte: Rechte): boolean {
  return rechte['faehigkeit.preise_sehen'] === 'JA';
}

/** Darf der Benutzer Belege versenden (E-Mail/Download-Freigabe)? */
export function darfBelegeSenden(rechte: Rechte): boolean {
  return rechte['faehigkeit.belege_senden'] === 'JA';
}

/** Darf der Benutzer Lieferscheine buchen/stornieren (Lagerabgang)? */
export function darfLieferscheineBuchen(rechte: Rechte): boolean {
  return rechte['faehigkeit.lieferscheine_buchen'] === 'JA';
}

/** Darf der Benutzer Zahlungen buchen? */
export function darfZahlungenBuchen(rechte: Rechte): boolean {
  return rechte['faehigkeit.zahlungen_buchen'] === 'JA';
}

/** Darf der Benutzer Korrekturbelege (Gutschrift, Stornorechnung) erstellen und festschreiben?
    Beides mindert Forderungen: wie im Backend (`STORNO_RECHTE`) braucht es Belege senden UND
    Zahlungen buchen (Standard: Admin, Geschäftsführer, Buchhaltung — nicht Verkäufer). */
export function darfKorrekturbelege(rechte: Rechte): boolean {
  return darfBelegeSenden(rechte) && darfZahlungenBuchen(rechte);
}

/** Darf der Benutzer diese Rechnung festschreiben bzw. per Mail erstversenden? Normale
    Rechnungen: Belege senden; eine Gutschrift bucht eine Verrechnung und braucht zusätzlich
    Zahlungen buchen (Backend `festschreib_rechte`). */
export function darfRechnungFestschreiben(rechte: Rechte, rechnungsart?: string | null): boolean {
  if (!darfBelegeSenden(rechte)) return false;
  return (rechnungsart ?? '').toUpperCase() === 'GUTSCHRIFT' ? darfZahlungenBuchen(rechte) : true;
}

/** Volles Recht: ALLE bzw. JA. */
export function istVoll(rechte: Rechte, schluessel: string): boolean {
  const wert = rechte[schluessel];
  return wert === 'ALLE' || wert === 'JA';
}
